// Reviewer/assignee selection of review and approval phases.
// Entries are {type, id}, where type is 'user', 'group' or 'work_queue'.

export const WORK_QUEUE_TYPE = 'work_queue';

export const toAssigneeValue = (entry) => `${entry.type}:${entry.id}`;

const toOption = (entry) => ({ value: toAssigneeValue(entry), label: entry.label });

// Groups the options when work queues are available
export const buildAssigneeOptions = (assignables = [], workQueues = []) => {
  if (workQueues.length === 0) return assignables.map(toOption);

  return [
    { label: I18n.t('work_queues'), options: workQueues.map(toOption) },
    { label: I18n.t('users_and_groups'), options: assignables.map(toOption) },
  ];
};

// A work queue can't be combined with users or groups, so the latest selection replaces the other kind
export const parseAssigneeSelection = (selected, previous) => {
  const entries = selected.map((value) => {
    const [type, id] = value.split(':');
    return { type, id };
  });
  const added = entries.find((e) => !previous.some((p) => p.type === e.type && String(p.id) === String(e.id)));

  if (!added) return entries;
  if (added.type === WORK_QUEUE_TYPE) return [added];
  return entries.filter((e) => e.type !== WORK_QUEUE_TYPE);
};

export const findAssigneeDetails = (entries, assignables = [], workQueues = []) => entries
  .map((r) => [...workQueues, ...assignables].find((a) => a.id == r.id && a.type == r.type))
  .filter(Boolean);
